export const TransitionSlideIn = (props) => {
    return (
        <div className={`w-full mb-12 sm:mb-8 xl:mb-0 relative transition-all duration-700 ease-in-out ${props.animate ?  'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-8'}`}>
            {props.children}
        </div>
    )
}